import * as RBHistoryConstants from "./RBHistoryConstants";
import { produce } from "immer";
import {
    STATUS_FAILURE,
    STATUS_SUCCESS,
    STATUS_PENDING,
  } from "Common/constants/commonConstants"; 
  

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    testName: "",
    rbHistoryTable: [],
    rbHistoryChart: [],
    availability: null,
    isRBHistLoading: STATUS_PENDING,
};

const RBHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case RBHistoryConstants.FETCH_RB_HISTORY_DATA:
            const getRBHistoryState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    testName: "",
                    rbHistoryTable: [],
                    rbHistoryChart: [],
                    availability: null,
                    isRBHistLoading: STATUS_PENDING,
                }
            });
            return assign({}, state, getRBHistoryState);

        case RBHistoryConstants.RB_HISTORY_DATA_FETCHED:
            const fetchedRBHistoryState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    testName: action.payload.newState.testName,
                    rbHistoryTable: action.payload.newState.rbLotNumberHistory,
                    rbHistoryChart: action.payload.newState.rbHistoryChart,
                    availability: action.payload.newState.availability,
                    isRBHistLoading: STATUS_SUCCESS,
                }
            });
            return assign({}, state, fetchedRBHistoryState);
        case RBHistoryConstants.RB_HISTORY_DATA_FETCHING_FAILED:
            const failedRBHistoryState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    testName: "",
                    rbHistoryTable: [],
                    rbHistoryChart: [],
                    availability: null,
                    isRBHistLoading: STATUS_FAILURE,
                }
            });
            return assign({}, state, failedRBHistoryState);
        default:
            return state;
    }
};

export default RBHistoryReducer;
